import React, { useRef, useState } from 'react';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';

import ServiceForm from './components/ServiceForm';

const NewServiceModal = ({
  service,
  isOpen,
  onClose = () => {},
  onSave = async (_service) => {},
  isLoading = false,
  isAdminContext = false,
  practice = null
}) => {
  const formRef = useRef(null);
  const [isFormChanged, setIsFormChanged] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      bodyClassName="flex justify-center flex-1"
      handleClose={onClose}
      width="medium"
      title={service?.id ? 'Edit service' : 'Create new service'}
      footer={
        <div className="flex w-full justify-between gap-3">
          <Button
            variant="tertiary"
            text="Cancel"
            onClick={onClose}
            id="closeServiceModalBtn"
            size="small"
          />
          <Button
            onClick={() => formRef.current?.submitForm()}
            text={service?.id ? 'Save changes' : 'Create new service'}
            id="createUpdateServiceBtn"
            data-qa="create-update-service-btn"
            isLoading={isLoading}
            isDisabled={!isFormChanged}
            size="small"
          />
        </div>
      }>
      <ServiceForm
        ref={formRef}
        service={service}
        onSave={onSave}
        isAdminContext={isAdminContext}
        practice={practice}
        onDirtyChange={setIsFormChanged}
      />
    </Modal>
  );
};

export default NewServiceModal;
